import * as React from 'react';
import { PropsWithChildren, ReactNode, useEffect, useState } from 'react';
import { Hierarchy, HierarchyApi } from '../../api/core';
import getLogger, { Logger } from '../../log';
import { Tooltip } from 'primereact/tooltip';
import { HierarchyEntity } from '../../Settings/data';

export interface HTTProps {
  entity: HierarchyEntity;
  id: number;
  name: string;
  extraProps?: any;
}

export interface HierarchyMapEntry {
  name: string;
  id: number;
}

export function HierarchyToolTipFacet(props: PropsWithChildren<HTTProps>): ReactNode {
  const [hierarchy, setHierarchy] = useState<HierarchyMapEntry[]>(undefined);

  useEffect((): void => {
  }, [hierarchy]);

  const api: HierarchyApi = new HierarchyApi();
  const logger: Logger = getLogger('HierarchyTooltip');

  const _fetchHierarchy = async (entity: HierarchyEntity, id: number): Promise<Hierarchy[]> => {
    switch (entity) {
      case HierarchyEntity.ORGS:
        return api.getOrganisationHierarchy({organisationId: id});
      case HierarchyEntity.PROJECTS:
        return api.getProjectHierarchy({projectId: id});
      default:
        logger.error('Illegal entity type', entity);
        return [];
    }
  };

  const fetchHierarchy = async (entity: HierarchyEntity, id: number): Promise<void> => {
    try {
      const hierarchyMapEntries: HierarchyMapEntry[] = (await _fetchHierarchy(entity, id))
        .sort((a: Hierarchy, b: Hierarchy): number => b.stage - a.stage)
        .map((e: Hierarchy): HierarchyMapEntry => ({id: e.entityId, name: e.name}));
      setHierarchy(hierarchyMapEntries);
    } catch (e) {
      setHierarchy(null);
    }
  };

  const handleMouseOver = (): void => {
    if (hierarchy === undefined) {
      setHierarchy(null);
      void fetchHierarchy(props.entity, props.id);
    }
  };

  const renderHierarchy = (): string => {
    if (!hierarchy || hierarchy.length === 0) {
      // Empty hierarchy
      return props.name;
    }
    return hierarchy.map((entry: HierarchyMapEntry): string => entry.name).join(' > ');
  };


  return (
    <>
      {hierarchy && <><Tooltip target={`.${props.entity}${props.id}`}></Tooltip>
        <span
          className={`${props.entity}${props.id}`}
          data-pr-tooltip={renderHierarchy()}
          data-pr-event={'both'}
          data-pr-position={'top'}
        >
        {props.children}
      </span></>}
      {!hierarchy && <span onMouseEnter={handleMouseOver}>
        {props.children}
      </span>}
    </>
  );
}
